<template>
    <transition name="player-fade" mode="out-in">
        <div
            v-if="player.panes.default"
            class="player">

            <TrackPreview v-if="player.panes.default?._item"
                :item="player.panes.default?._item"
                :row="true"
                :light="true"
                :invert="true"
                size="size-m"
            />

            <div class="buttons">
                <IconButton icon="player-back" sprite="player"
                    class="size-m invert tertiary"
                    :disabled="player.panes.default?.prevDisabled"
                    @click="prev"
                />

                <AudioToggle
                    :state="player.panes.default?._state"
                    :disabled="!player.panes.default?._item"
                    :light="true"
                    @play="play"
                    @pause="pause"
                />

                <IconButton icon="player-forward" sprite="player"
                    class="size-m invert tertiary"
                    :disabled="player.panes.default?.nextDisabled"
                    @click="next"
                />
            </div>
        </div>
    </transition>
</template>

<script setup>
    import { computed } from 'vue';
    import { useI18n } from 'vue-i18n';
    // import stores from '@/stores';
    import TrackPreview from '🔗/components/ui/TrackPreview.vue';
    import IconButton from '🔗/components/ui/IconButton.vue';
    import AudioToggle from '🔗/components/ui/AudioToggle.vue';

    const player = stores.player();
    window.q = player;

    const { t } = useI18n();

    const pause = () => {
        player.pause();
    }

    const play = () => {
        player.play();
    }

    const prev = () => {
        if (player.panes.default) {
            player.panes.default.prev();
        }
    }

    const next = () => {
        if (player.panes.default) {
            player.panes.default.next();
        }
    }
</script>

<style lang="scss" scoped>
    .player {
        display: flex;
        flex-direction: column;
        color: var(--white-500);
        background: var(--dark-500);
        width: 100%;
        padding: 8px 24px;
        gap: 8px;
        position: sticky;
        bottom: 0;
        z-index: 1;

        .audio-toggle {
            width: 64px;
            height: 64px;
            opacity: 1;
            background: transparent;
        }

        .buttons {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
        }

        &:before {
            content: "";
            position: absolute;
            bottom: -20px;
            left: 0;
            right: 0;
            min-height: 20px;
            background: linear-gradient(0deg, transparent 0%, var(--dark-500) 100%);
            display: block;
            z-index: 1;
        }

        &:after {
            content: "";
            position: absolute;
            top: -20px;
            left: 0;
            right: 0;
            min-height: 20px;
            background: linear-gradient(0deg, var(--dark-500) 0%, transparent 100%);
            display: block;
            z-index: 1;
        }
    }

    .player-fade-enter-active,
    .player-fade-leave-active {
        transition: all 0.3s ease;
    }

    .player-fade-enter-from,
    .player-fade-leave-to {
        opacity: 0;
        transform: translateY(20px);
    }

    .player-fade-enter-to,
    .player-fade-leave-from {
        opacity: 1;
        transform: translateY(0);
    }

</style>
